import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class LargeAbnormal extends BaseDangerDetail {
    constructor(props) {
        super(props);
    }

    getColumns = () => {
        return [{
            title: '资产减值损失',
            dataIndex: 'asseimpaloss'
        }, {
            title: '利润总额',
            dataIndex: 'totprofit'
        }, {
            title: '资产减值损失占利润总额比例',
            dataIndex: 'proportion'
        }];
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/details/LargeAbnormal.jsx